<div class="migration-validation-page p-4">
    <jjames-card>
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
            <div class="flex items-center gap-2">
                <mat-icon class="text-2xl text-indigo-600">verified</mat-icon>
                <h2 class="text-xl font-semibold">Migration Validation</h2>
            </div>
            <button mat-icon-button (click)="load()" [disabled]="isLoading()" matTooltip="Refresh">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>

        @if (isLoading()) {
        <div class="flex justify-center py-12">
            <mat-spinner diameter="48"></mat-spinner>
        </div>
        } @else if (hasError()) {
        <div class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <mat-icon class="text-5xl text-red-400">error_outline</mat-icon>
            <p class="mt-2 text-red-700">Failed to load validation results.</p>
            <button mat-stroked-button color="warn" class="mt-3" (click)="load()">Retry</button>
        </div>
        } @else if (!validation()) {
        <div class="text-center py-12 text-gray-500">
            <mat-icon class="text-6xl text-gray-300">rule</mat-icon>
            <p class="mt-2">No validation data available.</p>
        </div>
        } @else {
        <!-- Summary Banner -->
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6 flex flex-wrap gap-6 items-center">
            <div>
                <p class="text-xs text-gray-500 uppercase tracking-wide">Overall Match</p>
                <p class="text-3xl font-bold" [ngClass]="overallClass(validation()!.overallMatchPercent)">
                    {{ validation()!.overallMatchPercent !== undefined ? (validation()!.overallMatchPercent! |
                    number:'1.1-1') + '%' : '—' }}
                </p>
            </div>
            <div>
                <p class="text-xs text-gray-500 uppercase tracking-wide">Timestamp</p>
                <p class="text-sm font-medium text-gray-700">{{ validation()!.timestamp | date:'medium' }}</p>
            </div>
        </div>

        <!-- Categories Table -->
        <div class="overflow-x-auto">
            <table mat-table [dataSource]="validation()!.categories ?? []" class="w-full text-sm">

                <!-- name -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold">Category</th>
                    <td mat-cell *matCellDef="let row" class="font-medium">{{ row.name }}</td>
                </ng-container>

                <!-- description -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold">Description</th>
                    <td mat-cell *matCellDef="let row" class="text-gray-600">{{ row.description }}</td>
                </ng-container>

                <!-- oldDbCount -->
                <ng-container matColumnDef="oldDbCount">
                    <th mat-header-cell *matHeaderCellDef class="text-right font-semibold whitespace-nowrap">Old DB</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.oldDbCount ?? 0 }}</td>
                </ng-container>

                <!-- newDbCount -->
                <ng-container matColumnDef="newDbCount">
                    <th mat-header-cell *matHeaderCellDef class="text-right font-semibold whitespace-nowrap">New DB</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.newDbCount ?? 0 }}</td>
                </ng-container>

                <!-- difference -->
                <ng-container matColumnDef="difference">
                    <th mat-header-cell *matHeaderCellDef class="text-right font-semibold">Diff</th>
                    <td mat-cell *matCellDef="let row" class="text-right"
                        [ngClass]="(row.difference ?? 0) === 0 ? 'text-green-600' : 'text-red-600'">
                        {{ row.difference ?? 0 }}
                    </td>
                </ng-container>

                <!-- matchPercent -->
                <ng-container matColumnDef="matchPercent">
                    <th mat-header-cell *matHeaderCellDef class="text-right font-semibold whitespace-nowrap">Match %
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                        <span class="px-2 py-0.5 rounded-full text-xs font-medium"
                            [ngClass]="matchClass(row.matchPercent)">
                            {{ row.matchPercent !== undefined ? (row.matchPercent | number:'1.1-1') + '%' : '—' }}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
            </table>
        </div>
        }
    </jjames-card>
</div>